    import React, { useState, useEffect, useRef,useCallback } from 'react';
    import './home_page.css';
    import Background from "./Background";
    import { useNavigate } from 'react-router-dom';
    import Navbar from './Navbar.js'
    import video_brain from './brain-2.mp4';
    import video_brain2 from './brain-3.mp4';
    import video_brain3 from './brain-4.mp4';
    import video_brain4 from './doctor.mp4';

    const SLIDES = [
      { h1: "Stock Market Regulators", text: "We have developed a groundbreaking Cognitive Brain AI architecture specifically designed for regulators worldwide to monitor insider trading risks in the stock markets.", color: "#0004ff", type: "brain", path: "/products#regulators" },
      { h1: "Rational Brain Research", text: "Exploring the mathematical foundations of rational brain structure through the lens of neuro-science, epistemology, and the Philosophy of mind.", color: "#00ff77", video: video_brain, path: "/research#cognitive" },
      { h1: "Economic Research", text: "The objective of this economic research is to critically review an international research book that predicted the world economy a decade ahead.", color: "#cc2e2e", video: video_brain2, path: "/research#rational" },
      { h1: "AI Doctor", text: "The company has developed an AI Doctor avatar first of its kind in the World which never hallucinates and works based on evidence.", color: "#ff00ff", video: video_brain4, path: "/products#doctor" },
      { h1: "Generative AI Research", text: "The aim of this research is to find an optimal parameter small LLM model which can do as many language tasks as possible with minimum compute.", color: "#ffcc00", video: video_brain3, path: "/research#generative" }
    ];

    function App() {
      const [index, setIndex] = useState(0);
      const navigate = useNavigate();
      const [activeMenu, setActiveMenu] = useState(null);
      const timerRef = useRef(null);

      const handleNavigation = (path) => navigate(path);

      const showMenu = (id) => {
        if (timerRef.current) clearTimeout(timerRef.current);
        setActiveMenu(id);
      };

      const hideMenu = () => {
        timerRef.current = setTimeout(() => setActiveMenu(null), 1000);
      };

      const handleNext = useCallback(() => {
        setIndex((prev) => (prev + 1) % SLIDES.length);
      }, []);

      const handlePrev = () => {
        setIndex((prev) => (prev - 1 + SLIDES.length) % SLIDES.length);
      };

      useEffect(() => {
        const timer = setInterval(handleNext, 5000);
        return () => clearInterval(timer);
      }, [handleNext, index]);

      useEffect(() => {
        document.querySelectorAll('.typewriter-text').forEach(el => {
          el.style.animation = 'none';
          void el.offsetWidth;
          el.style.animation = '';
        });
      }, [index]);
      
      return (
        <div className="homepage">
          <Navbar/>
          <div className="slider-viewport">
            <div className="slider-track" style={{ transform: `translateX(-${index * 100}vw)` }}>
              {SLIDES.map((slide, i) => (
                <div className={`slide-unit ${i === index ? 'active' : ''}`} key={i}>
                  <div className="hero-content">
                    <div className="mobile-only-header">
                    <div className="mobile-bg-wrapper">
                      {slide.type === "brain" ? (
                        <Background color={slide.color} type={slide.type} />
                      ) : slide.video ? (
                        <video src={slide.video} className="hero-img-mobile" autoPlay muted loop playsInline />
                      ) : (
                        slide.img && <img src={slide.img} className="hero-img-mobile" alt=""/>
                      )}
                    </div>
                    </div>
                    <div className="text-side">
                      <h1 className="heading_h1">{slide.h1}</h1>
                      <div className="typewriter-container">
                        <p className="typewriter-text">{slide.text}</p>
                      </div>
                      <button className="explore_button" style={{ background: slide.color }} onClick={() => handleNavigation(slide.path)}>
                        Explore <span className="arrow">→</span>
                      </button>
                    </div>
                  <div className="image-side">
                    {slide.type === "brain" ? (
                      <div className="desktop-brain-container">
                        <Background color={slide.color} type={slide.type} />
                      </div>
                    ) : slide.video ? (
                      <video src={slide.video} className="hero-img" autoPlay muted loop playsInline />
                    ) : (
                      slide.img && <img src={slide.img} className="hero-img" alt=""/>
                    )}
                  </div>
                  </div>
                </div>
              ))}
            </div>

            <button className="nav-arrow left" onClick={handlePrev}>❮</button>
            <button className="nav-arrow right" onClick={handleNext}>❯</button>

            <div className="pagination-dots">
              {SLIDES.map((_, i) => (
                <span 
                  key={i} 
                  className={`dot ${i === index ? 'active' : ''}`} 
                  onClick={() => setIndex(i)}
                />
              ))}
            </div>
        </div>

          <div className="card-section">
            <div className="card about-card" onMouseEnter={() => showMenu('about')} onMouseLeave={hideMenu} onClick={() => handleNavigation('/about')}>
              <div className="card-icon">🏢</div>
              <h3>About Us</h3>
              <p>Cnyda Dynamics is a research-driven organization dedicated to AI excellence.</p>
            </div>

            <div className="card products-card" onMouseEnter={() => showMenu('products')} onMouseLeave={hideMenu} onClick={() => handleNavigation('/products')}>
              <div className={`card-menu ${activeMenu === 'products' ? 'visible' : ''}`}>
                <button onClick={(e) => { e.stopPropagation(); handleNavigation('/products#regulators'); }}>Regulators</button>
                <button onClick={(e) => { e.stopPropagation(); handleNavigation('/products#ai_doctor'); }}>AI Doctor</button>
              </div>
              <div className="card-icon">🛠️</div>
              <h3>Products</h3>
              <p>We design and develop high-quality, scalable AI products.</p>
            </div>

            <div className="card research-card" onMouseEnter={() => showMenu('research')} onMouseLeave={hideMenu} onClick={() => handleNavigation('/research')}>
              <div className={`card-menu ${activeMenu === 'research' ? 'visible' : ''}`}>
                <button onClick={(e) => { e.stopPropagation(); handleNavigation('/research#rational'); }}>Economic Research</button>
                <button onClick={(e) => { e.stopPropagation(); handleNavigation('/research#cognitive'); }}>Digital Brain Research</button>
                <button onClick={(e) => { e.stopPropagation(); handleNavigation('/research#generative'); }}>Generative AI Research</button>
              </div>
              <div className="card-icon">🔬</div>
              <h3>Research</h3>
              <p>Advanced research in robotics, AI, and emerging technologies.</p>
            </div>

            <div className="card patents-card" onMouseEnter={() => showMenu('patents')} onMouseLeave={hideMenu} onClick={() => handleNavigation('/patents')}>
              <div className={`card-menu ${activeMenu === 'patents' ? 'visible' : ''}`}>
                <button onClick={(e) => { e.stopPropagation(); handleNavigation('/patents#doctor'); }}>Doctor Patent</button>
                <button onClick={(e) => { e.stopPropagation(); handleNavigation('/patents#lawyer'); }}>Lawyer Patent</button>
                <button onClick={(e) => { e.stopPropagation(); handleNavigation('/patents#teacher'); }}>AI Teacher Patent</button>
                <button onClick={(e) => { e.stopPropagation(); handleNavigation('/patents#analytic'); }}>Analytic Patent</button>
              </div>
              <div className="card-icon">📜</div>
              <h3>Patents</h3>
              <p>Protecting innovation through global intellectual property.</p>
            </div>
          </div>
          <footer className="footer">
          <div className="footer-content">
            <div className="footer-info">
              <p className="footer-title">CNYDA DYNAMICS INC.</p>
              <div className="small-text">
                <p>Landmark: Two hours from Bangalore International airport via. KGF</p>
                <span className="designer">Web Designed & Managed By: T. Mouli Jaya</span>
              </div>
            </div>

            <div className="footer-nav">
              <ul className="footer-links">
                {/* <li><a href="/" aria-label="Home"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg></a></li>
                <li><a href="/research" aria-label="Research"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/><circle cx="11" cy="11" r="3"/></svg></a></li>
                <li><a href="/products" aria-label="Products"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg></a></li>
                <li><a href="/patents" aria-label="Patents"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/></svg></a></li>
                <li><a href="/about" aria-label="About Us"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg></a></li> */}
              </ul>
            </div>

            <div className="footer-social">
              <div className="social-links">
                <a href="https://www.linkedin.com/company/cnyda-dynamics" target="_blank" rel="noopener noreferrer">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
                </a>
                <p className='icon_text'>Follow us on LinkedIn</p>
              </div>
            </div>
          </div>
          <p className="copyright-text">Copyright ©2026 Cnyda Dynamics Inc.</p>
        </footer>
        </div>
      );
    }

    export default App;